export interface IAccountsPayableDetail {
    isChecked: boolean
    swapNumber: string,
    donorAlias: string,
    billingType: string,
    billableCenterId: number,
    billableCenterAlias: string,
    recipientAlias: string,
    invoiceDate: string,
    daysOutstanding: number,
    amount: number,
    payableCenterId: number,
    payableCenterAlias: string,
    isPaid: boolean
}